{
  "name": "business-card",
  "version": "3.2.2",
  "description": "Yevhen Fabizhevskyi's personal website.",
  "homepage": "https://fabasoad.github.io/business-card/",
  "scripts": {
    "build:dev": "vite build --mode development",
    "build:prod": "vite build",
    "lint": "biome lint --write src",
    "start:dev": "vite",
    "start:web": "PUBLIC_PATH=../dist nodemon --watch ./server server/app.js",
    "test": "vitest run --coverage --reporter=json --outputFile=vitest-report.json",
    "clean": "rm -rf coverage && rm -rf temp",
    "clean:unsafe": "rm -f package-lock.json && rm -rf node_modules"
  },
  "bugs": {
    "url": "https://github.com/fabasoad/business-card/issues",
    "email": "fabasoad@gmail.com"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/fabasoad/business-card.git"
  },
  "author": {
    "name": "Yevhen Fabizhevskyi",
    "email": "fabasoad@gmail.com",
    "url": "https://github.com/fabasoad"
  },
  "license": "ISC",
  "devDependencies": {
    "@biomejs/biome": "~2.5.4",
    "@testing-library/dom": "~10.4.1",
    "@testing-library/jest-dom": "~7.0.0",
    "@testing-library/react": "~16.3.2",
    "@types/node": "~26.1.1",
    "@types/react": "~19.2.17",
    "@types/react-dom": "~19.2.3",
    "@vitejs/plugin-react": "^6.0.3",
    "@vitest/coverage-v8": "~4.1.10",
    "bootstrap": "~5.3.8",
    "express": "~5.2.1",
    "express-rate-limit": "~8.6.0",
    "humanize-duration": "~3.34.0",
    "i18next": "~26.3.6",
    "jsdom": "~29.1.1",
    "nodemon": "~3.1.14",
    "react": "~19.2.7",
    "react-dom": "~19.2.7",
    "react-i18next": "~17.0.10",
    "sass": "~1.101.0",
    "typescript": "~7.0.2",
    "vite": "~8.1.5",
    "vitest": "~4.1.10"
  },
  "dependencies": {
    "@octokit/rest": "~22.0.1",
    "@tanstack/react-query": "~5.101.2",
    "posthog-js": "~1.405.3",
    "react-bootstrap": "~2.10.10"
  },
  "allowScripts": {
    "@parcel/watcher@2.5.6": true,
    "core-js@3.49.0": true,
    "fsevents@2.3.3": true
  }
}
